import { useContext } from 'react';

import CurrentlyViewedUserContext from 'packages/kakapo-ui-application/contexts/CurrentlyViewedUserContext';

/**
 * Return the currently viewed user and if it matches with the authenticated user.
 */
export default function useCurrentlyViewedUser() {
	return useContext(CurrentlyViewedUserContext)!;
}
